import React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

export function PQCardSkeleton(): React.ReactElement {
  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        borderRadius: '16px',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        px: '16px',
        py: '16px',
      }}
    >
      {/* Header row */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ pb: '12px' }}
      >
        <Stack direction="row" alignItems="center" gap="12px">
          <Skeleton variant="rounded" width={40} height={40} animation="wave" />
          <Stack spacing="4px">
            <Skeleton variant="text" width={160} height={20} animation="wave" />
            <Skeleton variant="text" width={80} height={16} animation="wave" />
          </Stack>
        </Stack>
        <Skeleton variant="rounded" width={72} height={30} animation="wave" />
      </Stack>
      {/* Footer row */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ pt: '12px', borderTop: '1px solid', borderColor: 'divider' }}
      >
        <Skeleton variant="text" width={140} height={16} animation="wave" />
        <Skeleton variant="rounded" width={110} height={30} animation="wave" />
      </Stack>
    </Box>
  );
}
